const aspectRatios = [
  { value: "16:10", display: "16:10" },
  { value: "16:9", display: "16:9" },
  { value: "4:3", display: "4:3" }
];

export default aspectRatios;
